import React, { useEffect, useRef, useState } from "react";
import { Box, LabelStyled } from "../../styled/Elements";
import { Form, FormGroup } from "react-bootstrap";
import styled from "styled-components";
import { Eye, Eyelash } from "../../styled/AllImages";
import { useTranslation } from "react-i18next";
import ValidationErrorText from "./ValidationErrorText";

const ValidatedInput = ({
  name,
  type,
  fieldType,
  placeholder,
  label,
  value,
  register,
  validationRules,
  className,
  disabled,
  errors,
  sectIndex,
  staric,
  classNameLabel,
  errorDisplay,
  errorMessage = "",
  outline = false,
  ...rest
}) => {
  const { t } = useTranslation();
  const [showType, setType] = useState(fieldType);

  const inputStyles = type === "textarea" ? { height: "130px" } : {};
  const inputRef = useRef(null);
  const hasError = !!errors?.[name];
  const isValid = !hasError && value;

  useEffect(() => {
    if (fieldType === "number" && inputRef.current) {
      const input = inputRef.current;
      const preventScroll = (e) => e.preventDefault();
      input.addEventListener("wheel", preventScroll, { passive: false });
      return () => input.removeEventListener("wheel", preventScroll);
    }
  }, [fieldType]);

  return (
    <ValidatedInputWrapper className={className} {...rest}>
      <FormGroup controlId={name} className="formEleContainer">
        {label && (
          <LabelStyled
            className={classNameLabel}
            size="15px"
            color="var(--text)"
          >
            {t(label)}
            {staric && <span className="staric">*</span>}
          </LabelStyled>
        )}
        <Box className="position-relative w-100">
          <Form.Control
            as={type}
            ref={inputRef}
            type={showType}
            value={value}
            disabled={disabled}
            placeholder={t(placeholder)}
            style={inputStyles}
            className={`${
              value && outline
                ? hasError
                  ? "input-invalid"
                  : isValid
                  ? "input-valid"
                  : ""
                : ""
            }`}
            min={fieldType === "number" ? 0 : undefined}
            onKeyDown={(e) => {
              if (fieldType === "number" && (e.key === "-" || e.key === "e")) {
                e.preventDefault();
              }
            }}
            {...(register && register(name, validationRules))}
          />
          {fieldType === "password" && (
            <>
              {showType === "password" ? (
                <Eyelash
                  className="eye-btn position-absolute cursor-pointer"
                  onClick={() => setType("text")}
                />
              ) : (
                <Eye
                  className="eye-btn position-absolute cursor-pointer"
                  onClick={() => setType("password")}
                />
              )}
            </>
          )}

          {errors && (
            <>
              {errors[name]?.type === "required" && (
                <ValidationErrorText
                  text={
                    t(errors[name]?.message) ||
                    `${t(label || name)} ${t("isRequired")}.`
                  }
                  extraClass={errorDisplay}
                />
              )}
              {errors?.users?.[sectIndex]?.name?.type === "required" && (
                <ValidationErrorText
                  text={
                    t(errors.users?.[sectIndex]?.name?.message) ||
                    `${t(label || "name")} ${t("isRequired")}.`
                  }
                  extraClass={errorDisplay}
                />
              )}

              {errors[name]?.type === "minLength" && (
                <ValidationErrorText
                  text={t(errors[name]?.message)}
                  extraClass={errorDisplay}
                />
              )}

              {errors[name]?.type === "maxLength" && (
                <ValidationErrorText
                  text={t(errors[name]?.message)}
                  extraClass={errorDisplay}
                />
              )}

              {errors[name]?.type === "pattern" && (
                <ValidationErrorText
                  text={t(errors[name]?.message || errorMessage)}
                  extraClass={errorDisplay}
                />
              )}
              {errors[name]?.type === "validate" && (
                <ValidationErrorText
                  text={t(errors[name]?.message || errorMessage)}
                  extraClass={errorDisplay}
                />
              )}
            </>
          )}
        </Box>
      </FormGroup>
    </ValidatedInputWrapper>
  );
};

export default ValidatedInput;

export const ValidatedInputWrapper = styled.div`
  width: 100%;
  padding: 9px 25px 9px 25px;
  border-bottom: 1px solid var(--borderLight);
  width: 100%;
  .form-control.input-valid {
    border: 1px solid var(--themeColor2) !important;
  }
  .form-control.input-invalid {
    border: 1px solid var(--redColor) !important;
  }
  .formEleContainer {
    display: flex;
    padding: 7px 0px 7px 0px;
    margin: 7px 0 7px 0;
    align-items: center;
    gap: 5px;
    & > label {
      min-width: 160px;
      body.rtl & {
        font-family: var(--arRegular);
      }

      &.w-auto {
        min-width: auto;
      }
    }
    &.inp-white {
      input {
        background-color: var(--white);
      }
    }
  }
  &.combined {
    border-bottom: none;
    padding: 8px 25px 8px 25px;
    /* &:last-child{
            border-bottom: 1px solid var(--borderLight);
        } */
    .formEleContainer {
      display: flex;
      padding: 0;
      margin: 0;
    }
  }
  &.flex-wrap {
    .formEleContainer {
      flex-wrap: wrap;
      label {
        width: 100%;
      }
    }
  }
  .form-floating {
    width: 100%;
  }
  input[type="text"] {
    width: 100%;
  }

  .form-control {
    height: 48px;
    box-shadow: none;
    outline: none;
    border-radius: 10px;
    border: 1px solid var(--border);
    background-color: ${({ bg }) => (bg ? bg : "var(--bgSecondary)")};
    &::placeholder {
      color: var(--textPlaceholder2);
    }
  }
  .form-control:focus {
    box-shadow: none;
    outline: none;
    border: 1px solid var(--border);
  }
  @media (max-width: 767px) {
    .formEleContainer {
      flex-wrap: wrap;
      gap: 3px;
      margin: 0;
      padding: 3px 0px 3px 0px;
      label {
        width: 100%;
      }
    }
  }
`;
